import React from 'react';
import PageActions from '../AppLayout/PageActions';
import FirmTabs from './FirmTabs';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const FirmPageHeader = () => {
    return (
        <>
            <PageActions title="Firm" />
            <Typography><strong>This tab is moving soon.</strong></Typography>
            <Typography>For now, legacy firm administrators can access firm features here <strong>and</strong> in the Portal, all firm management features will soon only be accessed in the Portal.</Typography>
            <Typography>Need access to the Firm Portal? Contact your account manager.</Typography>
            <FirmTabs />
        </>
    );
};

export default FirmPageHeader;
